/**
 * Purpose: Business-specific dashboard header — identity + a link back to the
 *          public page. Lives under businesses/ (NOT in the generic dashboard
 *          namespace) because it knows business routes; the generic
 *          DashboardLayout takes it as an opaque `header` node.
 * Inputs: business.
 * Outputs: header row with the business name and a "View public page" action.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../../ui';

const EXTERNAL_D = 'M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14';

const DashboardHeader = ({ business }) => {
  const navigate = useNavigate();

  return (
    <header className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-900">
      <div className="min-w-0">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-700 dark:text-brand-300">
          Owner dashboard
        </p>
        <h1 className="truncate text-lg font-bold text-gray-900 dark:text-gray-100 sm:text-xl">
          {business.name}
        </h1>
      </div>

      <CTAButton
        variant="secondary"
        size="sm"
        onClick={() => navigate(`/businesses/${business.slug || business.id}`)}
        icon={
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={EXTERNAL_D} />
          </svg>
        }
      >
        View public page
      </CTAButton>
    </header>
  );
};

export default DashboardHeader;
